var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9589 14.9154C31.3599 6.09839 23.728 -0.560764 14.9137 0.0381659C10.5227 0.337364 6.66677 2.38268 3.97559 5.44666L3.96759 5.44133C3.94839 5.46586 3.93186 5.4904 3.91532 5.51493C1.24281 8.59811 -0.261184 12.6946 0.0374808 17.0866C0.065214 17.5058 0.11428 17.9164 0.174547 18.3239C0.174547 18.3436 0.17988 18.3596 0.182547 18.3788C0.223613 18.6471 0.270546 18.9159 0.322279 19.1788C0.371316 19.4219 0.426087 19.6637 0.486545 19.9042C2.33507 27.2727 9.23796 32.4913 17.0854 31.9574C25.8997 31.358 32.5615 23.7265 31.9621 14.9101L31.9589 14.9154ZM28.4762 15.1533C28.5504 16.2381 28.4816 17.3005 28.2874 18.3244C28.2874 18.3191 28.2821 18.3138 28.2821 18.3079C27.1205 15.4738 24.8261 13.4258 22.8107 12.2946C23.2187 7.49199 21.5893 5.46586 19.744 5.13733C19.3865 5.07016 19.0189 5.07679 18.664 5.15682C18.3091 5.23685 17.9743 5.38858 17.6802 5.6027C17.3861 5.81682 17.1388 6.08881 16.9536 6.40196C16.7684 6.71511 16.6492 7.06281 16.6032 7.42372C16.5583 7.77187 16.5825 8.12546 16.6744 8.46425C16.7663 8.80305 16.9241 9.12039 17.1388 9.39811C17.3535 9.67583 17.6209 9.90847 17.9256 10.0827C18.2303 10.257 18.5664 10.3694 18.9147 10.4136C19.0432 10.4301 19.1691 10.4354 19.2923 10.4328C19.3013 10.6042 19.3059 10.7758 19.3062 10.9474C17.6 10.5261 16.0064 10.4408 14.5526 10.5725C14.0059 10.6084 13.4618 10.6769 12.9233 10.7778C13.1046 9.15651 13.7147 7.33305 14.895 6.00239C16.0363 4.7128 17.7344 3.97627 19.5851 4.16507C19.936 4.20081 20.311 4.28827 20.6475 4.4008C20.664 4.40614 20.6805 4.41147 20.6944 4.41414C24.9824 6.16133 28.1397 10.2328 28.4736 15.1533H28.4762ZM17.3238 17.5959C17.3238 17.5959 17.3238 17.5986 17.3211 17.6013C16.9166 18.1826 16.4582 18.7245 15.952 19.2199C15.1855 18.4101 14.5365 17.4967 14.0241 16.5063C13.9995 16.4541 13.9723 16.4077 13.9473 16.3554V16.3501C13.647 15.7082 13.4069 15.04 13.2299 14.3538C14.3659 14.0855 15.4806 13.9869 16.5462 14.0391L16.7158 14.0471H16.7211C17.3894 14.1021 18.0848 14.2253 18.8048 14.4226C18.4706 15.5464 17.9724 16.6148 17.3264 17.5933L17.3238 17.5959ZM11.8582 4.19814L11.8502 4.20881C9.97448 6.62959 9.34995 9.63864 9.37769 11.9496C5.01292 13.9975 4.07639 16.421 4.71158 18.1842C4.72758 18.2338 4.74732 18.2802 4.76652 18.3271C5.04018 18.9808 5.56219 19.4991 6.21783 19.7682C6.87346 20.0372 7.60908 20.0349 8.26303 19.7618C8.91674 19.4881 9.43505 18.9661 9.70407 18.3105C9.97308 17.6548 9.97079 16.9192 9.69769 16.2653C9.64798 16.1491 9.59042 16.0365 9.52542 15.9282C9.66249 15.8375 9.81022 15.7479 9.96915 15.6546C10.4561 17.3442 11.1766 18.7708 12.0171 19.9644C12.3211 20.4162 12.6497 20.8514 13.0081 21.2706C11.5131 21.925 9.62942 22.3084 7.8849 21.9522C6.19851 21.6076 4.71158 20.5068 3.94786 18.8087C3.80155 18.4757 3.69141 18.1279 3.61932 17.7714C3.57429 17.4652 3.54049 17.1574 3.51799 16.8487C3.12866 11.1176 6.6833 6.01626 11.8582 4.19814ZM16.847 28.4774C13.4438 28.71 10.2619 27.5495 7.8577 25.4844C10.8918 25.8983 13.8107 24.934 15.799 23.7543C19.7552 26.5116 22.3237 26.1116 23.5339 24.6796C23.771 24.4032 23.9491 24.0813 24.0572 23.7336C24.1654 23.3859 24.2014 23.0198 24.1629 22.6577C24.1244 22.2956 24.0124 21.9452 23.8336 21.6279C23.6548 21.3107 23.4131 21.0334 23.1232 20.813C22.844 20.6001 22.5256 20.4444 22.1862 20.3547C21.8468 20.2649 21.4931 20.243 21.1452 20.29C20.7973 20.3371 20.462 20.4522 20.1587 20.6289C19.8553 20.8056 19.5897 21.0403 19.3771 21.3196C19.3008 21.421 19.232 21.5308 19.1718 21.6402C19.0267 21.566 18.8731 21.4839 18.7174 21.3938C19.8321 20.2437 20.7456 18.9144 21.4197 17.4615C21.6611 16.9698 21.8732 16.4642 22.0549 15.9474C23.3696 16.917 24.6453 18.3543 25.2096 20.0434C25.7547 21.6754 25.5461 23.5153 24.4565 25.0247C24.2413 25.3175 23.9952 25.5864 23.7227 25.8268L23.712 25.8375C21.743 27.3884 19.3511 28.3077 16.8502 28.4748L16.847 28.4774Z",
    fill: "url(#paint0_linear_564_228)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.9,
    d: "M19.7441 5.13472C19.4439 5.07773 19.1361 5.07412 18.8347 5.12406C20.3659 5.95605 21.48 8.2755 20.8944 12.8536C20.7005 14.3425 20.2631 15.7894 19.5995 17.1362C19.0277 18.3653 18.2835 19.5066 17.3894 20.5256C17.8133 20.8444 18.2568 21.1362 18.7174 21.3992C19.8323 20.2493 20.746 18.9202 21.4203 17.4674C22.0854 16.1212 22.523 14.6741 22.7152 13.1848C23.4139 7.73577 21.6998 5.48512 19.7446 5.13686L19.7441 5.13472Z",
    fill: "url(#paint1_radial_564_228)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8938 12.8509C21.4799 8.27496 20.3652 5.95338 18.8346 5.12085C18.7743 5.12885 18.7172 5.14272 18.6564 5.15658C20.1546 6.01898 21.233 8.33523 20.6554 12.8509C20.4615 14.3398 20.024 15.7867 19.3604 17.1336C18.8093 18.3192 18.097 19.4229 17.2437 20.4136C17.2927 20.4519 17.3397 20.4877 17.3887 20.5229C18.282 19.5033 19.026 18.3619 19.5983 17.133C20.2636 15.7868 20.7013 14.3402 20.8938 12.8509Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5,
    d: "M15.0753 23.2311C14.9302 23.1218 14.7932 23.0066 14.654 22.8914C12.3948 23.8338 9.26468 24.4247 6.1543 23.702C6.66084 24.3508 7.23037 24.9478 7.85455 25.4844C10.8887 25.8983 13.8076 24.934 15.7958 23.7543C15.5515 23.5836 15.3104 23.4083 15.0726 23.2284L15.0753 23.2311Z",
    fill: "url(#paint2_radial_564_228)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6,
    d: "M14.656 22.8914C14.5877 22.8338 14.5168 22.7767 14.4512 22.7191C12.1755 23.6279 9.02938 24.173 5.927 23.398C6.0038 23.4994 6.0806 23.6034 6.15687 23.702C9.26511 24.4247 12.3968 23.8338 14.656 22.8914Z",
    fill: "url(#paint3_linear_564_228)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.9,
    d: "M4.71436 18.1874C4.73036 18.2364 4.75009 18.2834 4.76929 18.3298C4.87062 18.5708 5.00182 18.7868 5.16075 18.9815C5.11702 17.2402 6.56821 15.1122 10.8231 13.3325C12.2094 12.7559 13.6812 12.4117 15.1794 12.3138C16.5301 12.1933 17.8911 12.2672 19.2209 12.533C19.2897 11.9581 19.3169 11.4215 19.3116 10.9474C17.7585 10.5564 16.1506 10.4297 14.5554 10.5725C13.057 10.6706 11.5851 11.0148 10.1986 11.5911C5.13089 13.7106 4.03809 16.3202 4.71489 18.19V18.1874H4.71436Z",
    fill: "url(#paint4_radial_564_228)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.8
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.823 13.3352C6.5681 15.1154 5.11638 17.2429 5.16065 18.9842C5.19905 19.0306 5.24011 19.0749 5.28118 19.1186C5.27798 17.3906 6.7457 15.2989 10.9435 13.5405C12.3298 12.964 13.8016 12.6198 15.2998 12.5219C16.6022 12.4067 17.9142 12.4713 19.199 12.7139C19.2076 12.6538 19.2149 12.5935 19.2208 12.5331C17.8908 12.2688 16.53 12.1952 15.1792 12.3144C13.6811 12.4126 12.2094 12.7568 10.823 13.333V13.3352Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4,
    d: "M22.7206 13.1821C22.6992 13.3629 22.6688 13.5379 22.6384 13.716C24.5824 15.2003 26.6608 17.6178 27.592 20.6706C27.8998 19.9068 28.1318 19.1145 28.2848 18.3053C27.1264 15.4712 24.832 13.4253 22.8166 12.2947C22.792 12.5827 22.7616 12.8755 22.7232 13.1821H22.7206Z",
    fill: "url(#paint5_radial_564_228)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5,
    d: "M22.6385 13.7159C22.622 13.8034 22.6081 13.8941 22.5916 13.9815C24.5169 15.4983 26.5622 17.9495 27.4411 21.0242C27.4929 20.9068 27.5425 20.7884 27.5889 20.6711C26.6582 17.6178 24.5825 15.2029 22.6353 13.7159H22.6385Z",
    fill: "url(#paint6_linear_564_228)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.9,
    d: "M23.5339 24.6769C23.7318 24.4438 23.8892 24.1792 23.9995 23.894C22.5126 24.8028 19.9462 24.6087 16.2748 21.8124C15.0813 20.9008 14.0469 19.7979 13.2135 18.5485C12.4337 17.4392 11.8168 16.224 11.3815 14.9399C10.8503 15.1671 10.3714 15.4135 9.96069 15.6546C10.3996 17.195 11.0937 18.6509 12.014 19.9618C12.8353 21.1884 13.8593 22.2978 15.0753 23.2258C19.4454 26.5553 22.2523 26.1964 23.5307 24.6764H23.5339V24.6769Z",
    fill: "url(#paint7_radial_564_228)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.8
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2774 21.813C19.9461 24.6082 22.5146 24.8028 24.001 23.8935C24.0229 23.8364 24.0421 23.7788 24.0586 23.7239C22.5637 24.5922 20.0171 24.3644 16.3974 21.6077C15.2039 20.696 14.1695 19.5931 13.336 18.3437C12.5851 17.2738 11.9853 16.1055 11.5537 14.8717C11.4961 14.8962 11.4417 14.9181 11.3867 14.9426C11.8218 16.2269 12.4386 17.4423 13.2182 18.5517C14.0395 19.7783 15.0635 20.8877 16.2795 21.8157L16.2768 21.813H16.2774Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3,
    d: "M10.1958 11.5858C10.3627 11.517 10.5296 11.4541 10.6992 11.3911C11.0118 8.96502 12.0656 5.95597 14.2459 3.62585C13.4299 3.74319 12.6272 3.93519 11.8496 4.20612C9.97336 6.6269 9.34937 9.63595 9.3771 11.9474C9.63683 11.8247 9.9083 11.7037 10.1931 11.5863L10.1958 11.5858Z",
    fill: "url(#paint8_radial_564_228)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4,
    d: "M10.6987 11.3912C10.7841 11.3613 10.8662 11.3282 10.951 11.2984C11.3014 8.87173 12.4022 5.87655 14.623 3.57629C14.4971 3.59016 14.3707 3.60669 14.2448 3.62323C12.0651 5.95601 11.0113 8.96239 10.6993 11.3885V11.3912H10.6987Z",
    fill: "url(#paint9_linear_564_228)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M14.9137 0.0387158C10.5217 0.337381 6.66678 2.3827 3.97506 5.44668L3.91479 5.51495C4.43746 6.03548 6.15158 7.05947 6.84438 7.48667C8.2249 5.99939 9.94686 4.8707 11.8614 4.19816C11.9958 4.02269 12.1377 3.85042 12.2859 3.68349C14.0929 1.64351 16.56 0.567246 19.424 0.567246C19.7419 0.567246 20.391 0.619512 20.4043 0.619512C18.6222 0.106863 16.7641 -0.0898827 14.9142 0.0381824L14.9137 0.0387158Z",
    fill: "url(#paint10_linear_564_228)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M16.847 28.4802C13.4438 28.7127 10.262 27.5522 7.85772 25.4876C7.63193 25.4581 7.40726 25.4206 7.18413 25.3751C4.51428 24.83 2.34576 23.2311 0.916436 20.7533C0.759051 20.4794 0.615581 20.1978 0.486572 19.9095C2.33509 27.278 9.23798 32.4972 17.0827 31.9628C17.1185 31.1553 16.8801 29.2802 16.8443 28.4802H16.847Z",
    fill: "url(#paint11_linear_564_228)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M31.9595 14.9154C31.4667 14.8658 29.0678 15.0551 28.4769 15.1532C28.5505 16.238 28.4822 17.3004 28.2876 18.3244C28.3697 18.5271 28.4492 18.7351 28.5201 18.9457C29.383 21.5308 29.0817 24.206 27.6524 26.6865C27.4941 26.9598 27.3224 27.225 27.1377 27.4812C27.1377 27.4812 27.1457 27.4753 27.1484 27.47C30.399 24.3073 32.2907 19.7948 31.9595 14.918V14.9154Z",
    fill: "url(#paint12_linear_564_228)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M19.5883 4.16243C19.9387 4.19816 20.3136 4.28562 20.6506 4.39816C20.6666 4.40349 20.6837 4.40882 20.697 4.41149C22.0706 4.9721 23.3341 5.77125 24.4293 6.77201C24.4293 6.77201 24.4346 6.77468 24.4373 6.77734C24.9632 6.17788 25.9733 5.51815 25.9733 5.51815C25.9733 5.51815 24.4266 3.93523 22.0581 3.44243C20.4016 3.09737 16.664 2.76617 14.3062 6.77734L14.328 6.75601C14.5035 6.49254 14.687 6.23548 14.8976 5.99975C16.0395 4.71016 17.7371 3.97309 19.5883 4.16243Z",
    fill: "url(#paint13_linear_564_228)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M24.4565 25.0273C24.2413 25.3201 23.9952 25.589 23.7227 25.8294C23.712 25.8401 23.6981 25.8513 23.6869 25.8625C22.5146 26.771 21.191 27.4652 19.7771 27.9131C19.7744 27.9131 19.7718 27.9131 19.7686 27.9158C20.0262 28.6715 20.0918 29.8763 20.0918 29.8763C20.0918 29.8763 22.2357 29.3291 23.8464 27.5243C24.9717 26.262 27.129 23.19 24.8341 19.1431C24.8341 19.1431 24.8373 19.1564 24.8427 19.1729C24.9851 19.4556 25.1136 19.7452 25.2123 20.0439C25.7573 21.6759 25.5488 23.5158 24.4592 25.0246L24.4565 25.0273Z",
    fill: "url(#paint14_linear_564_228)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M3.95388 18.8146C3.80735 18.4814 3.69703 18.1335 3.62482 17.7767C3.62215 17.7607 3.61682 17.7437 3.61415 17.7271C3.41148 16.2514 3.47708 14.7565 3.79228 13.3165V13.308C3.00882 13.1544 1.93309 12.6072 1.93309 12.6072C1.93309 12.6072 1.33576 14.7405 2.09469 17.0349C2.62589 18.6418 4.20561 22.0455 8.85731 22.0813C8.85731 22.0813 8.84398 22.078 8.82745 22.0727C8.51278 22.0535 8.19812 22.021 7.88879 21.9581C6.20187 21.613 4.71494 20.5122 3.95068 18.8146H3.95388Z",
    fill: "url(#paint15_linear_564_228)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M18.9147 10.4114C19.0433 10.4274 19.1691 10.4328 19.2923 10.4301C19.2923 10.4301 19.2075 8.76826 19.0049 7.91386C18.7995 7.06213 18.4982 6.4952 18.1697 6.17521C17.9318 5.94534 17.1841 5.66001 16.6038 7.41786C16.5588 7.76601 16.5829 8.11962 16.6747 8.45845C16.7666 8.79727 16.9243 9.11466 17.139 9.39243C17.3536 9.6702 17.621 9.9029 17.9257 10.0772C18.2304 10.2515 18.5665 10.364 18.9147 10.4082V10.4109V10.4114Z",
    fill: "url(#paint16_linear_564_228)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M9.70136 16.2706C9.65145 16.1546 9.59372 16.0422 9.52856 15.9341C9.52856 15.9341 8.1291 16.8375 7.4939 17.4397C6.85871 18.0423 6.51898 18.5874 6.40698 19.0333C6.32751 19.3538 6.45338 20.1426 8.26616 19.7671C8.91988 19.4935 9.43819 18.9715 9.70721 18.3158C9.97622 17.6602 9.97392 16.9246 9.70082 16.2706H9.70136Z",
    fill: "url(#paint17_linear_564_228)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M19.3804 21.317C19.3036 21.4183 19.2353 21.5282 19.175 21.637C19.175 21.637 20.6566 22.3959 21.4972 22.645C22.3377 22.8946 22.9782 22.9164 23.4193 22.79C23.7372 22.6999 24.3558 22.1932 23.126 20.8135C22.8468 20.6008 22.5284 20.4451 22.1891 20.3554C21.8497 20.2657 21.496 20.2438 21.1482 20.2908C20.8004 20.3379 20.4652 20.453 20.1619 20.6296C19.8586 20.8062 19.593 21.0409 19.3804 21.3202V21.317Z",
    fill: "url(#paint18_linear_564_228)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M18.8054 14.4253C18.4694 15.5426 17.998 16.5586 17.4204 17.4535C17.39 17.4999 17.3601 17.5469 17.327 17.5959C17.327 17.5959 17.327 17.5986 17.3244 17.6013C16.9199 18.1826 16.4615 18.7246 15.9553 19.2199C16.3223 19.6087 16.7164 19.9863 17.1521 20.3453C17.6469 20.7345 18.1704 21.0859 18.718 21.3964C19.8329 20.2466 20.7466 18.9175 21.4209 17.4647C21.6621 16.9728 21.874 16.467 22.0555 15.9501C21.4918 15.5368 20.9222 15.2056 20.3969 14.981C19.879 14.7591 19.3464 14.5734 18.8028 14.4253H18.806H18.8054Z",
    fill: "url(#paint19_linear_564_228)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.85827 25.4876C10.8919 25.9009 13.8108 24.9372 15.799 23.7569C15.5547 23.5862 15.3136 23.4109 15.0758 23.2311C14.3197 22.6526 13.6261 21.9966 13.0065 21.2738C11.511 21.9276 9.62733 22.3111 7.8828 21.9548C6.19642 21.6103 4.70949 20.5095 3.94523 18.8119C3.79889 18.4787 3.68875 18.1308 3.6167 17.774C4.05776 20.8679 5.61829 23.5676 7.85561 25.4871L7.85827 25.4876Z",
    fill: "url(#paint20_linear_564_228)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M15.9548 19.2195C15.1885 18.4098 14.5396 17.4965 14.0274 16.5064C14.0028 16.4541 13.9751 16.4077 13.9506 16.3555V16.3501C13.6503 15.7083 13.4102 15.04 13.2332 14.3539C12.7127 14.4771 12.19 14.6307 11.6642 14.828C11.0804 15.0613 10.5148 15.3376 9.97192 15.6547C10.4594 17.3443 11.1794 18.7709 12.0199 19.9645C12.3239 20.4162 12.653 20.8514 13.0119 21.2706C13.6519 20.9912 14.2247 20.66 14.6812 20.3176C15.131 19.9798 15.5574 19.6121 15.9575 19.2168L15.9548 19.2195Z",
    fill: "url(#paint21_linear_564_228)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M11.8506 4.20877C9.97487 6.62955 9.35034 9.6386 9.37808 11.9495C9.6484 11.8226 9.92135 11.7013 10.1967 11.5858C11.0744 11.2191 11.9885 10.9465 12.9237 10.7725C13.105 9.15114 13.7151 7.32768 14.8954 5.99702C16.0367 4.70743 17.7348 3.97037 19.586 4.1597C19.9364 4.19544 20.3113 4.2829 20.6484 4.39543C20.6644 4.40077 20.6809 4.4061 20.6948 4.40877C18.9378 3.69181 17.0397 3.38747 15.1466 3.51917C13.9967 3.59864 12.8959 3.83117 11.8554 4.1981C11.8527 4.20077 11.8501 4.2061 11.8474 4.20877H11.8506Z",
    fill: "url(#paint22_linear_564_228)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M28.2847 18.3026C27.1242 15.4685 24.8293 13.42 22.8138 12.2893C22.7893 12.5773 22.7594 12.8728 22.7178 13.1821C22.5956 14.1254 22.3745 15.0531 22.0581 15.9501C23.3728 16.9197 24.6485 18.357 25.2128 20.0466C25.7573 21.6786 25.5493 23.5186 24.4597 25.0274C24.2444 25.3202 23.9984 25.5891 23.7258 25.8295L23.7152 25.8402C26.0645 23.9948 27.7258 21.3335 28.2959 18.3218C28.2959 18.3165 28.2906 18.3106 28.2906 18.3053L28.2847 18.3026Z",
    fill: "url(#paint23_linear_564_228)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M12.9152 12.7C12.9822 13.2579 13.0873 13.8104 13.2299 14.3539C14.3664 14.0856 15.4805 13.987 16.5461 14.0392L16.7157 14.0472H16.7211C17.3893 14.1022 18.0848 14.2254 18.8053 14.4227C18.9584 13.9107 19.0874 13.379 19.1802 12.8259C19.2816 12.1363 19.3114 11.4979 19.3088 10.9422C17.6032 10.5208 16.0096 10.4355 14.5557 10.5672C14.009 10.6031 13.4649 10.6717 12.9264 10.7726C12.8496 11.468 12.8464 12.1278 12.9179 12.6979L12.9152 12.7Z",
    fill: "url(#paint24_linear_564_228)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_564_228",
    x1: 5.08118,
    y1: 26.9196,
    x2: 25.4805,
    y2: 6.51759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#703AC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0070EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#0297FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0AE2FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_564_228",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.5601 12.7603) scale(6.08423)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_564_228",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.5681 24.0471) scale(3.54045 3.54045)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_564_228",
    x1: 6.25553,
    y1: 23.4476,
    x2: 9.66778,
    y2: 23.4007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_564_228",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.9144 13.6685) rotate(-120) scale(6.08423)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_564_228",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.1855 15.8131) rotate(-120) scale(3.54045)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_564_228",
    x1: 27.3211,
    y1: 20.7111,
    x2: 25.5745,
    y2: 17.7799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_564_228",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.2351 21.2866) rotate(120) scale(6.08423)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_564_228",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.244 8.13946) rotate(120) scale(3.54045)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_564_228",
    x1: 14.4171,
    y1: 3.83709,
    x2: 12.7537,
    y2: 6.81681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_564_228",
    x1: 15.1606,
    y1: 2.32243,
    x2: 9.94676,
    y2: 3.83922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_564_228",
    x1: 5.31107,
    y1: 22.2018,
    x2: 9.67051,
    y2: 26.7522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_564_228",
    x1: 28.7068,
    y1: 21.5169,
    x2: 30.2235,
    y2: 16.9058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_564_228",
    x1: 17.5344,
    y1: 4.96189,
    x2: 24.5226,
    y2: 6.56134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_564_228",
    x1: 24.7925,
    y1: 22.8486,
    x2: 19.9099,
    y2: 28.1019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_564_228",
    x1: 5.6712,
    y1: 20.1933,
    x2: 3.56455,
    y2: 13.3405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_564_228",
    x1: 19.0625,
    y1: 7.5384,
    x2: 16.8529,
    y2: 9.75118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_564_228",
    x1: 7.14084,
    y1: 17.5746,
    x2: 10.1606,
    y2: 18.3858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_564_228",
    x1: 21.7926,
    y1: 22.8823,
    x2: 20.9836,
    y2: 19.8637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_564_228",
    x1: 17.1958,
    y1: 20.197,
    x2: 18.5238,
    y2: 18.3655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_564_228",
    x1: 12.6284,
    y1: 19.4034,
    x2: 9.97506,
    y2: 20.6684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_564_228",
    x1: 11.6642,
    y1: 14.9864,
    x2: 12.4855,
    y2: 16.6925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_564_228",
    x1: 15.4842,
    y1: 9.71807,
    x2: 14.9172,
    y2: 7.76021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_564_228",
    x1: 21.6122,
    y1: 18.6855,
    x2: 23.2549,
    y2: 19.0637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_564_228",
    x1: 19.0352,
    y1: 13.1358,
    x2: 16.9514,
    y2: 12.7576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAze);
export default __webpack_public_path__ + "static/media/aze.c760e7543b4b03fac2af2d825774bdd4.svg";
export { ForwardRef as ReactComponent };